export default __webpack_public_path__ + "static/media/tweet2.1028bcd8.svg";